module.exports = __webpack_public_path__ + "static/on-416a7a7495f209fec6b630e1110e6f21.png";